module.exports = __webpack_public_path__ + "static/hacibaba-sm-24f26cd2f9329980d4712edbb15257cc.jpg";